import React, {Component} from 'react';
import reactCSS from 'reactcss'
import BoxElementItem from './BoxElementItem'
import { SketchPicker, ChromePicker } from 'react-color'

class BoxShadow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            displayColorPicker: false
        };
    }

    onChangeHandle(e){
        var direction = e.target.getAttribute('data-direction');
        const { input: { value, onChange } } = this.props;

        let mainValue = ['0', '0', '0', '0', '#fff'];
        if(value && value != ''){
            mainValue = value.split(' ');
        }
        
        if(direction == 'horizontal'){
            mainValue[0] = e.target.value || 0;
        } else if(direction == 'vertical'){
            mainValue[1] = e.target.value || 0;
        } else if(direction == 'blur'){
            mainValue[2] = e.target.value || 0;
        } else if(direction == 'spread'){
            mainValue[3] = e.target.value || 0;
        }

        onChange(mainValue.join(' '));
    }

    handleColorChange(color){
        const { input: { onChange, value } } = this.props
        
        var mainColor = `rgba(${ color.rgb.r },${ color.rgb.g },${ color.rgb.b },${ color.rgb.a })`;
    
        if(color.rgb.a == 1){
            mainColor = color.hex;
        }

        let mainValue = ['0', '0', '0', '0', '#fff'];
        if(value && value != ''){
            mainValue = value.split(' ');
        }

        mainValue[4] = mainColor;

        onChange(mainValue.join(' '));
    }

    handleChangeInput(e){
        const { input: { onChange, value } } = this.props

        let mainValue = ['0', '0', '0', '0', '#fff'];
        if(value && value != ''){
            mainValue = value.split(' ');
        }

        mainValue[4] = e.target.value;

        onChange(mainValue.join(' '));
      }


    handleClick(){
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    }

    handleClose(){
        this.setState({ displayColorPicker: false })
    }
    render() {
        const { input: { value }, params } = this.props

        let mainValue = ['0', '0', '0', '0', '#fff'];
        if(value && value != ''){
            mainValue = value.split(' ');
        }
        

        

        const styles = reactCSS({
            'default': {
                wrapper:{
                    position: 'relative',
                    padding: '3px 0'
                },
                colorContainer: {
                    display: 'inline-block',
                    backgroundImage: `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAH5JREFUWAntlUsKACEMQ6vMjXr/I/RMOmtdBuRR0mWxGPIhY/0Tx1TVsYnIzGv34t28foUtDFAVBM/g98LoSsDwDBpg+5AMN4mosUMiEhh4Bt0k7SXGexAP0E3ikKgMqPf4kLhJ2kuM9yAeoJvEIVEZUO/xIXGTtJcY70E8wA3sHG3hUj6LrAAAAABJRU5ErkJggg==')`,
                    borderRadius: '2px',
                    border: '1px solid #eff1f4'
                },
                color: {
                    width: '32px',
                    height: '16px',
                    borderRadius: '2px',
                    backgroundColor: `${ mainValue[4] }`,
                },
                swatch: {
                    position: 'relative',
                    height: '28px',
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '2px',
                    display: 'block',
                    cursor: 'pointer',
                    boxShadow: '0 0 10px 0 rgba(109,120,131,0.10)'
                },
                input: {
                    position: 'absolute',
                    top: '0px',
                    left: '44px',
                    border: 'none',
                    boxShadow: 'none',
                    zIndex: '2',
                    width: 'calc(100% - 44px)',
                    height: '28px'
                },
                popover: {
                    //position: 'absolute',
                    zIndex: '2',
                    marginTop: '0px'
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });

        return (
            <div className="sp-pagebuilder-form-group" style={ styles.wrapper }>
                <label style={ styles.title }>
                    { params.title }
                    {
                    typeof params.desc != 'undefined' && params.desc != '' &&
                    <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
                        <i className="fa fa-question-circle" />
                    </LinkWithTooltip>
                    }
                </label>
                <div style={ styles.swatch } onClick={ this.handleClick.bind(this) }>
                    <div style={styles.colorContainer}><div style={ styles.color } /></div>
                    <input style={ styles.input } type="text" value={mainValue[4]} onChange={this.handleChangeInput.bind(this)} />
                </div>
                {
                    this.state.displayColorPicker ?
                    <div style={ styles.popover } className="clearfix">
                        <div style={ styles.cover } onClick={ this.handleClose.bind(this) }/>
                        <ChromePicker color={ mainValue[4] } onChange={ this.handleColorChange.bind(this) } />
                    </div>
                    : null
                }
                <div className="sppb-box-element clearfix sp-pagebuilder-boxshadow-list">
                    <BoxElementItem
                        direction="horizontal"
                        elmValue = { mainValue[0] }
                        itemChangeHandle = {this.onChangeHandle.bind(this)}
                    />
                    <BoxElementItem
                        direction="vertical"
                        elmValue = { mainValue[1] }
                        itemChangeHandle = {this.onChangeHandle.bind(this)}
                    />
                    <BoxElementItem
                        direction="blur"
                        elmValue = { mainValue[2] }
                        itemChangeHandle = {this.onChangeHandle.bind(this)}
                    />
                    <BoxElementItem
                        direction="spread"
                        elmValue = { mainValue[3] }
                        itemChangeHandle = {this.onChangeHandle.bind(this)}
                    />
                </div>
            </div>
        )
    }
}

export default BoxShadow;


// WEBPACK FOOTER //
// ./src/helpers/form/types/BoxShadow.js